var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "heat-loss-calc" }, [
    _c("div", { staticClass: "step" }, [
      _c("h2", [_vm._v("Select your calculator")]),
      _vm._v(" "),
      _c("div", { staticClass: "fields" }, [
        _c("div", { staticClass: "field" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.activeCalculator,
                  expression: "activeCalculator"
                }
              ],
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.activeCalculator = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            _vm._l(_vm.calculators, function(calculator, index) {
              return _c(
                "option",
                { key: index, domProps: { value: calculator.handle } },
                [_vm._v(_vm._s(calculator.label))]
              )
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.activeUnit,
                  expression: "activeUnit"
                }
              ],
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.activeUnit = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            _vm._l(_vm.units, function(unit, index) {
              return _c(
                "option",
                { key: index, domProps: { value: unit.handle } },
                [_vm._v(_vm._s(unit.label))]
              )
            }),
            0
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.activeCalculator == "room"
      ? _c("div", { staticClass: "calculator" }, [
          _c("div", { staticClass: "step" }, [
            _c("h2", [_vm._v("Floors")]),
            _vm._v(" "),
            _c("div", { staticClass: "fields" }, [
              _c(
                "div",
                {
                  staticClass: "field",
                  class: {
                    error: !_vm.floorLevelIsValid && _vm.room.floorsInvalid
                  }
                },
                [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.room.floorLevel,
                          expression: "room.floorLevel"
                        }
                      ],
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.room,
                            "floorLevel",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { disabled: "", value: "" } }, [
                        _vm._v("Floor level of room")
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.floorTypes, function(floor, index) {
                        return _c(
                          "option",
                          { key: index, domProps: { value: floor.handle } },
                          [_vm._v(_vm._s(floor.label))]
                        )
                      })
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "field",
                  class: {
                    error: !_vm.roomHeightIsValid && _vm.room.floorsInvalid
                  }
                },
                [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.room.roomHeight,
                          expression: "room.roomHeight"
                        }
                      ],
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.room,
                            "roomHeight",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { disabled: "", value: "" } }, [
                        _vm._v("Room height")
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.possibleRoomHeights, function(height, index) {
                        return _c(
                          "option",
                          {
                            key: index,
                            domProps: { value: height.normalisedValue }
                          },
                          [
                            _vm._v(
                              _vm._s(height.value) + _vm._s(_vm.lengthSymbol)
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "field",
                  class: {
                    error: !_vm.floorAreaIsValid && _vm.room.floorsInvalid
                  }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.room.floorArea,
                        expression: "room.floorArea"
                      }
                    ],
                    attrs: { placeholder: "Floor area. 0" },
                    domProps: { value: _vm.room.floorArea },
                    on: {
                      keypress: _vm.allowNumbers,
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.room, "floorArea", $event.target.value)
                      }
                    }
                  }),
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.areaSymbol) }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.room.floorsInvalid,
                    expression: "room.floorsInvalid"
                  }
                ],
                staticClass: "errors"
              },
              [
                !_vm.floorLevelIsValid
                  ? _c("li", [
                      _vm._v(
                        "Please enter a floor level. Floor level of room must be selected."
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.roomHeightIsValid
                  ? _c("li", [
                      _vm._v(
                        "Please enter a room height. Room height must be selected."
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.floorAreaIsValid
                  ? _c("li", [
                      _vm._v(
                        "Please enter the floor area. Floor area must be set and not equal to 0."
                      )
                    ])
                  : _vm._e()
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "step" },
            [
              _c("h2", [_vm._v("External Walls & Windows")]),
              _vm._v(" "),
              _vm._l(_vm.room.externalWalls, function(wall, index) {
                return _c("div", { key: index, staticClass: "wall" }, [
                  _c("div", { staticClass: "fields" }, [
                    _c("div", { staticClass: "field" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.room.externalWalls[index].wallType,
                              expression: "room.externalWalls[index].wallType"
                            }
                          ],
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.room.externalWalls[index],
                                "wallType",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        _vm._l(_vm.wallTypes, function(wallOption, index) {
                          return _c(
                            "option",
                            {
                              key: index,
                              domProps: {
                                value: wallOption.value,
                                selected: wallOption.value == wall.value
                              }
                            },
                            [_vm._v(_vm._s(wallOption.label))]
                          )
                        }),
                        0
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.room.externalWalls[index].wallLength,
                            expression: "room.externalWalls[index].wallLength"
                          }
                        ],
                        domProps: {
                          value: _vm.room.externalWalls[index].wallLength
                        },
                        on: {
                          keypress: _vm.allowNumbers,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.room.externalWalls[index],
                              "wallLength",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.lengthSymbol) }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.room.externalWalls[index].windowType,
                              expression: "room.externalWalls[index].windowType"
                            }
                          ],
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.room.externalWalls[index],
                                  "windowType",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              function($event) {
                                return _vm.senseCheckExternalWallsWindowArea(
                                  index
                                )
                              }
                            ]
                          }
                        },
                        _vm._l(_vm.windowTypes, function(windowOption, index) {
                          return _c(
                            "option",
                            {
                              key: index,
                              domProps: {
                                value: windowOption.value,
                                selected: windowOption.value == wall.value
                              }
                            },
                            [_vm._v(_vm._s(windowOption.label))]
                          )
                        }),
                        0
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.room.externalWalls[index].windowArea,
                            expression: "room.externalWalls[index].windowArea"
                          }
                        ],
                        attrs: {
                          disabled:
                            _vm.room.externalWalls[index].windowType === "2"
                        },
                        domProps: {
                          value: _vm.room.externalWalls[index].windowArea
                        },
                        on: {
                          keypress: _vm.allowNumbers,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.room.externalWalls[index],
                              "windowArea",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.areaSymbol) }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.removeExternalWallToRoom(index)
                          }
                        }
                      },
                      [_vm._v("Remove Wall")]
                    )
                  ])
                ])
              }),
              _vm._v(" "),
              _c("div", [
                _c("p", [_vm._v("Add a new wall to the calculation")]),
                _vm._v(" "),
                _c("div", { staticClass: "fields" }, [
                  _c(
                    "div",
                    {
                      staticClass: "field",
                      class: {
                        error:
                          !_vm.wallTypeIsValid && _vm.room.externalWallInvalid
                      }
                    },
                    [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.room.externalWall.wallType,
                              expression: "room.externalWall.wallType"
                            }
                          ],
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.room.externalWall,
                                "wallType",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { disabled: "", value: "" } }, [
                            _vm._v("Outside wall type")
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.wallTypes, function(wallOption, index) {
                            return _c(
                              "option",
                              {
                                key: index,
                                domProps: { value: wallOption.value }
                              },
                              [_vm._v(_vm._s(wallOption.label))]
                            )
                          })
                        ],
                        2
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "field",
                      class: {
                        error:
                          !_vm.wallLengthIsValid && _vm.room.externalWallInvalid
                      }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.room.externalWall.wallLength,
                            expression: "room.externalWall.wallLength"
                          }
                        ],
                        attrs: { placeholder: "Length of outside wall. 0" },
                        domProps: { value: _vm.room.externalWall.wallLength },
                        on: {
                          keypress: _vm.allowNumbers,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.room.externalWall,
                              "wallLength",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.lengthSymbol) }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "field",
                      class: {
                        error:
                          !_vm.windowTypeIsValid && _vm.room.externalWallInvalid
                      }
                    },
                    [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.room.externalWall.windowType,
                              expression: "room.externalWall.windowType"
                            }
                          ],
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.room.externalWall,
                                  "windowType",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              _vm.senseCheckExternalWallWindowArea
                            ]
                          }
                        },
                        [
                          _c("option", { attrs: { disabled: "", value: "" } }, [
                            _vm._v("Window type")
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.windowTypes, function(
                            windowOption,
                            index
                          ) {
                            return _c(
                              "option",
                              {
                                key: index,
                                domProps: { value: windowOption.value }
                              },
                              [_vm._v(_vm._s(windowOption.label))]
                            )
                          })
                        ],
                        2
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "field",
                      class: {
                        error:
                          !_vm.windowAreaIsValid && _vm.room.externalWallInvalid
                      }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.room.externalWall.windowArea,
                            expression: "room.externalWall.windowArea"
                          }
                        ],
                        attrs: {
                          placeholder: "Area of window. 0",
                          disabled: _vm.room.externalWall.windowType === "2"
                        },
                        domProps: { value: _vm.room.externalWall.windowArea },
                        on: {
                          keypress: _vm.allowNumbers,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.room.externalWall,
                              "windowArea",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.areaSymbol) }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("button", { on: { click: _vm.addExternalWallToRoom } }, [
                    _vm._v("Add Wall")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "ul",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.room.externalWallInvalid,
                      expression: "room.externalWallInvalid"
                    }
                  ],
                  staticClass: "errors"
                },
                [
                  !_vm.wallTypeIsValid
                    ? _c("li", [
                        _vm._v(
                          "Please enter a wall type. The type of wall must be selected."
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.wallLengthIsValid
                    ? _c("li", [
                        _vm._v(
                          "Please enter a wall length. Wall length must be set and not equal to 0."
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.windowTypeIsValid
                    ? _c("li", [
                        _vm._v(
                          'Please enter a window type. The type of window must be selected. If the wall has no window, please select "No Window"'
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.windowAreaIsValid
                    ? _c("li", [
                        _vm._v(
                          "Please enter a window area. Window area must be set and not equal to 0."
                        )
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "ul",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.room.externalWallsInvalid,
                      expression: "room.externalWallsInvalid"
                    }
                  ],
                  staticClass: "errors"
                },
                [
                  _c("li", [
                    _vm._v(
                      "Please enter a wall. At least one wall must be set."
                    )
                  ])
                ]
              )
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "step" }, [
            _c("h2", [_vm._v("Variation")]),
            _vm._v(" "),
            _c("div", { staticClass: "fields checkboxes" }, [
              _c("div", { staticClass: "field" }, [
                _c(
                  "label",
                  {
                    staticClass: "checkbox-label",
                    attrs: { for: "coolerRoom" }
                  },
                  [
                    _c("span", [_vm._v("Cooler room")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.room.variation.coolerRoom,
                          expression: "room.variation.coolerRoom"
                        }
                      ],
                      attrs: { type: "checkbox", id: "coolerRoom" },
                      domProps: {
                        checked: Array.isArray(_vm.room.variation.coolerRoom)
                          ? _vm._i(_vm.room.variation.coolerRoom, null) > -1
                          : _vm.room.variation.coolerRoom
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.room.variation.coolerRoom,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.room.variation,
                                  "coolerRoom",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.room.variation,
                                  "coolerRoom",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.room.variation, "coolerRoom", $$c)
                          }
                        }
                      }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field" }, [
                _c(
                  "label",
                  {
                    staticClass: "checkbox-label",
                    attrs: { for: "exposedSituations" }
                  },
                  [
                    _c("span", [_vm._v("Exposed situations")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.room.variation.exposedSituations,
                          expression: "room.variation.exposedSituations"
                        }
                      ],
                      attrs: { type: "checkbox", id: "exposedSituations" },
                      domProps: {
                        checked: Array.isArray(
                          _vm.room.variation.exposedSituations
                        )
                          ? _vm._i(_vm.room.variation.exposedSituations, null) >
                            -1
                          : _vm.room.variation.exposedSituations
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.room.variation.exposedSituations,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.room.variation,
                                  "exposedSituations",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.room.variation,
                                  "exposedSituations",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(
                              _vm.room.variation,
                              "exposedSituations",
                              $$c
                            )
                          }
                        }
                      }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field" }, [
                _c(
                  "label",
                  {
                    staticClass: "checkbox-label",
                    attrs: { for: "internalRoomWithFanExtractor" }
                  },
                  [
                    _c("span", [_vm._v("Internal room with fan extractor")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.room.variation.internalRoomWithFanExtractor,
                          expression:
                            "room.variation.internalRoomWithFanExtractor"
                        }
                      ],
                      attrs: {
                        type: "checkbox",
                        id: "internalRoomWithFanExtractor"
                      },
                      domProps: {
                        checked: Array.isArray(
                          _vm.room.variation.internalRoomWithFanExtractor
                        )
                          ? _vm._i(
                              _vm.room.variation.internalRoomWithFanExtractor,
                              null
                            ) > -1
                          : _vm.room.variation.internalRoomWithFanExtractor
                      },
                      on: {
                        change: function($event) {
                          var $$a =
                              _vm.room.variation.internalRoomWithFanExtractor,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.room.variation,
                                  "internalRoomWithFanExtractor",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.room.variation,
                                  "internalRoomWithFanExtractor",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(
                              _vm.room.variation,
                              "internalRoomWithFanExtractor",
                              $$c
                            )
                          }
                        }
                      }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field" }, [
                _c(
                  "label",
                  {
                    staticClass: "checkbox-label",
                    attrs: { for: "allWindowWalls" }
                  },
                  [
                    _c("span", [_vm._v("All window walls")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.room.variation.allWindowWalls,
                          expression: "room.variation.allWindowWalls"
                        }
                      ],
                      attrs: { type: "checkbox", id: "allWindowWalls" },
                      domProps: {
                        checked: Array.isArray(
                          _vm.room.variation.allWindowWalls
                        )
                          ? _vm._i(_vm.room.variation.allWindowWalls, null) > -1
                          : _vm.room.variation.allWindowWalls
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.room.variation.allWindowWalls,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.room.variation,
                                  "allWindowWalls",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.room.variation,
                                  "allWindowWalls",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.room.variation, "allWindowWalls", $$c)
                          }
                        }
                      }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field" }, [
                _c(
                  "label",
                  {
                    staticClass: "checkbox-label",
                    attrs: { for: "singleStoryBuilding" }
                  },
                  [
                    _c("span", [_vm._v("Single story building")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.room.variation.singleStoryBuilding,
                          expression: "room.variation.singleStoryBuilding"
                        }
                      ],
                      attrs: { type: "checkbox", id: "singleStoryBuilding" },
                      domProps: {
                        checked: Array.isArray(
                          _vm.room.variation.singleStoryBuilding
                        )
                          ? _vm._i(
                              _vm.room.variation.singleStoryBuilding,
                              null
                            ) > -1
                          : _vm.room.variation.singleStoryBuilding
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.room.variation.singleStoryBuilding,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.room.variation,
                                  "singleStoryBuilding",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.room.variation,
                                  "singleStoryBuilding",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(
                              _vm.room.variation,
                              "singleStoryBuilding",
                              $$c
                            )
                          }
                        }
                      }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field" }, [
                _c(
                  "label",
                  {
                    staticClass: "checkbox-label",
                    attrs: {
                      for:
                        "ceilingWithoutInsulationOnTopFloorsAndSingleStoryBuildings"
                    }
                  },
                  [
                    _c("span", [
                      _vm._v(
                        "Ceiling without insulation on top floors and single story buildings"
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.room.variation
                              .ceilingWithoutInsulationOnTopFloorsAndSingleStoryBuildings,
                          expression:
                            "room.variation.ceilingWithoutInsulationOnTopFloorsAndSingleStoryBuildings"
                        }
                      ],
                      attrs: {
                        type: "checkbox",
                        id:
                          "ceilingWithoutInsulationOnTopFloorsAndSingleStoryBuildings"
                      },
                      domProps: {
                        checked: Array.isArray(
                          _vm.room.variation
                            .ceilingWithoutInsulationOnTopFloorsAndSingleStoryBuildings
                        )
                          ? _vm._i(
                              _vm.room.variation
                                .ceilingWithoutInsulationOnTopFloorsAndSingleStoryBuildings,
                              null
                            ) > -1
                          : _vm.room.variation
                              .ceilingWithoutInsulationOnTopFloorsAndSingleStoryBuildings
                      },
                      on: {
                        change: function($event) {
                          var $$a =
                              _vm.room.variation
                                .ceilingWithoutInsulationOnTopFloorsAndSingleStoryBuildings,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.room.variation,
                                  "ceilingWithoutInsulationOnTopFloorsAndSingleStoryBuildings",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.room.variation,
                                  "ceilingWithoutInsulationOnTopFloorsAndSingleStoryBuildings",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(
                              _vm.room.variation,
                              "ceilingWithoutInsulationOnTopFloorsAndSingleStoryBuildings",
                              $$c
                            )
                          }
                        }
                      }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field" }, [
                _c(
                  "label",
                  {
                    staticClass: "checkbox-label",
                    attrs: { for: "floorWithInsulation" }
                  },
                  [
                    _c("span", [_vm._v("Floor with insulation")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.room.variation.floorWithInsulation,
                          expression: "room.variation.floorWithInsulation"
                        }
                      ],
                      attrs: { type: "checkbox", id: "floorWithInsulation" },
                      domProps: {
                        checked: Array.isArray(
                          _vm.room.variation.floorWithInsulation
                        )
                          ? _vm._i(
                              _vm.room.variation.floorWithInsulation,
                              null
                            ) > -1
                          : _vm.room.variation.floorWithInsulation
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.room.variation.floorWithInsulation,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.room.variation,
                                  "floorWithInsulation",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.room.variation,
                                  "floorWithInsulation",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(
                              _vm.room.variation,
                              "floorWithInsulation",
                              $$c
                            )
                          }
                        }
                      }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field" }, [
                _c(
                  "label",
                  {
                    staticClass: "checkbox-label",
                    attrs: { for: "veluxWindowsOrSkylights" }
                  },
                  [
                    _c("span", [_vm._v("Velux windows or skylights")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.room.variation.veluxWindowsOrSkylights,
                          expression: "room.variation.veluxWindowsOrSkylights"
                        }
                      ],
                      attrs: {
                        type: "checkbox",
                        id: "veluxWindowsOrSkylights"
                      },
                      domProps: {
                        checked: Array.isArray(
                          _vm.room.variation.veluxWindowsOrSkylights
                        )
                          ? _vm._i(
                              _vm.room.variation.veluxWindowsOrSkylights,
                              null
                            ) > -1
                          : _vm.room.variation.veluxWindowsOrSkylights
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.room.variation.veluxWindowsOrSkylights,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.room.variation,
                                  "veluxWindowsOrSkylights",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.room.variation,
                                  "veluxWindowsOrSkylights",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(
                              _vm.room.variation,
                              "veluxWindowsOrSkylights",
                              $$c
                            )
                          }
                        }
                      }
                    })
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          this.room.variation.veluxWindowsOrSkylights
            ? _c(
                "div",
                { staticClass: "step" },
                [
                  _c("h2", [_vm._v("Velux / Skylight Options")]),
                  _vm._v(" "),
                  _vm._l(_vm.room.skylights, function(skylight, index) {
                    return _c("div", { key: index, staticClass: "skylight" }, [
                      _c("div", { staticClass: "fields" }, [
                        _c("div", { staticClass: "field" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.room.skylights[index].skylightType,
                                  expression:
                                    "room.skylights[index].skylightType"
                                }
                              ],
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.room.skylights[index],
                                    "skylightType",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            _vm._l(_vm.windowTypes, function(
                              skylightOption,
                              index
                            ) {
                              return _c(
                                "option",
                                {
                                  key: index,
                                  attrs: {
                                    disabled: skylightOption.value == "2"
                                  },
                                  domProps: {
                                    value: skylightOption.value,
                                    selected:
                                      skylightOption.value == skylight.value
                                  }
                                },
                                [_vm._v(_vm._s(skylightOption.label))]
                              )
                            }),
                            0
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "field" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.room.skylights[index].skylightArea,
                                expression: "room.skylights[index].skylightArea"
                              }
                            ],
                            domProps: {
                              value: _vm.room.skylights[index].skylightArea
                            },
                            on: {
                              keypress: _vm.allowNumbers,
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.room.skylights[index],
                                  "skylightArea",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _c("span", {
                            domProps: { innerHTML: _vm._s(_vm.areaSymbol) }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "remove",
                            on: {
                              click: function($event) {
                                return _vm.removeSkylightToRoom(index)
                              }
                            }
                          },
                          [_vm._v("Remove Skylight")]
                        )
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _c("p", [_vm._v("Add a new skylight to the calculation")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "fields" }, [
                    _c(
                      "div",
                      {
                        staticClass: "field",
                        class: {
                          error:
                            !_vm.skylightTypeIsValid && _vm.room.skylightInvalid
                        }
                      },
                      [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.room.skylight.skylightType,
                                expression: "room.skylight.skylightType"
                              }
                            ],
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.room.skylight,
                                  "skylightType",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "option",
                              { attrs: { disabled: "", value: "" } },
                              [_vm._v("Window type")]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.windowTypes, function(
                              skylightOption,
                              index
                            ) {
                              return _c(
                                "option",
                                {
                                  key: index,
                                  attrs: {
                                    disabled: skylightOption.value == "2"
                                  },
                                  domProps: { value: skylightOption.value }
                                },
                                [_vm._v(_vm._s(skylightOption.label))]
                              )
                            })
                          ],
                          2
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "field",
                        class: {
                          error:
                            !_vm.skylightAreaIsValid && _vm.room.skylightInvalid
                        }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.room.skylight.skylightArea,
                              expression: "room.skylight.skylightArea"
                            }
                          ],
                          attrs: { placeholder: "Area of skylight. 0" },
                          domProps: { value: _vm.room.skylight.skylightArea },
                          on: {
                            keypress: _vm.allowNumbers,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.room.skylight,
                                "skylightArea",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.lengthSymbol) }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "add",
                        on: { click: _vm.addSkylightToRoom }
                      },
                      [_vm._v("Add Skylight")]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.room.skylightInvalid,
                          expression: "room.skylightInvalid"
                        }
                      ],
                      staticClass: "errors"
                    },
                    [
                      !_vm.skylightTypeIsValid
                        ? _c("li", [
                            _vm._v(
                              "Please enter a skylight type. The type of skylight must be selected."
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.skylightAreaIsValid
                        ? _c("li", [
                            _vm._v(
                              "Please enter the area skylight. Skylight area must be set and not equal to 0."
                            )
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.room.skylightsInvalid,
                          expression: "room.skylightsInvalid"
                        }
                      ],
                      staticClass: "errors"
                    },
                    [
                      _c("li", [
                        _vm._v(
                          'Please enter a skylight. At least one skylight must be set if opting for the "Velux windows or skylights" variation.'
                        )
                      ])
                    ]
                  )
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "step" }, [
            _c("h2", [_vm._v("Total")]),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "calculate", on: { click: _vm.roomCalculate } },
              [_vm._v("Calculate")]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "total" }, [
              _vm._v("Your room requires an output of... "),
              _c("span", { staticClass: "field inline" }, [
                _c("input", {
                  attrs: { disabled: "" },
                  domProps: { value: _vm.room.lastCalculatedValue }
                }),
                _c("span", [_vm._v(" WATTS")])
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.activeCalculator == "conservatory"
      ? _c("div", { staticClass: "calculator" }, [
          _c("div", { staticClass: "step" }, [
            _c("h2", [_vm._v("Type")]),
            _vm._v(" "),
            _c("div", { staticClass: "fields" }, [
              _c(
                "div",
                {
                  staticClass: "field",
                  class: {
                    error:
                      !_vm.conservatoryTypeIsValid &&
                      _vm.conservatory.conservatoryInvalid
                  }
                },
                [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.conservatory.type,
                          expression: "conservatory.type"
                        }
                      ],
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.conservatory,
                            "type",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { selected: "true", value: "" } }, [
                        _vm._v("Glazing")
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.conservatoryTypes, function(glazing, index) {
                        return _c(
                          "option",
                          { key: index, domProps: { value: glazing.value } },
                          [_vm._v(_vm._s(glazing.label))]
                        )
                      })
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "field",
                  class: {
                    error:
                      !_vm.conservatoryHeightIsValid &&
                      _vm.conservatory.conservatoryInvalid
                  }
                },
                [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.conservatory.roomHeight,
                          expression: "conservatory.roomHeight"
                        }
                      ],
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.conservatory,
                            "roomHeight",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { selected: "true", value: "" } }, [
                        _vm._v("Room Height")
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.possibleConservatoryHeights, function(
                        height,
                        index
                      ) {
                        return _c(
                          "option",
                          { key: index, domProps: { value: height.value } },
                          [_vm._v(_vm._s(height.label))]
                        )
                      })
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "field",
                  class: {
                    error:
                      !_vm.conservatoryAreaIsValid &&
                      _vm.conservatory.conservatoryInvalid
                  }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.conservatory.floorArea,
                        expression: "conservatory.floorArea"
                      }
                    ],
                    attrs: { placeholder: "Floor Area. 0" },
                    domProps: { value: _vm.conservatory.floorArea },
                    on: {
                      keypress: _vm.allowNumbers,
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.conservatory,
                          "floorArea",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.areaSymbol) }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "field",
                  class: {
                    error:
                      !_vm.conservatoryWallsIsValid &&
                      _vm.conservatory.conservatoryInvalid
                  }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.conservatory.lengthOfWalls,
                        expression: "conservatory.lengthOfWalls"
                      }
                    ],
                    attrs: { placeholder: "Length Of Outside Wall(s). 0" },
                    domProps: { value: _vm.conservatory.lengthOfWalls },
                    on: {
                      keypress: _vm.allowNumbers,
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.conservatory,
                          "lengthOfWalls",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.lengthSymbol) }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.conservatory.conservatoryInvalid,
                    expression: "conservatory.conservatoryInvalid"
                  }
                ],
                staticClass: "errors"
              },
              [
                !_vm.conservatoryTypeIsValid
                  ? _c("li", [
                      _vm._v(
                        "Please enter a floor level. Floor level of room must be selected."
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.conservatoryHeightIsValid
                  ? _c("li", [
                      _vm._v(
                        "Please enter a room height. Room height must be selected."
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.conservatoryAreaIsValid
                  ? _c("li", [
                      _vm._v(
                        "Please enter the floor area. Floor area must be set and not equal to 0."
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.conservatoryWallsIsValid
                  ? _c("li", [
                      _vm._v(
                        "Please enter the floor area. Floor area must be set and not equal to 0."
                      )
                    ])
                  : _vm._e()
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "step" }, [
            _c("h2", [_vm._v("Variation")]),
            _vm._v(" "),
            _c("div", { staticClass: "fields checkboxes" }, [
              _c("div", { staticClass: "field" }, [
                _c(
                  "label",
                  {
                    staticClass: "checkbox-label",
                    attrs: { for: "forBackgroundHeatOnly" }
                  },
                  [
                    _c("span", [_vm._v("For background heat only")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.conservatory.variation.forBackgroundHeatOnly,
                          expression:
                            "conservatory.variation.forBackgroundHeatOnly"
                        }
                      ],
                      attrs: { type: "checkbox", id: "forBackgroundHeatOnly" },
                      domProps: {
                        checked: Array.isArray(
                          _vm.conservatory.variation.forBackgroundHeatOnly
                        )
                          ? _vm._i(
                              _vm.conservatory.variation.forBackgroundHeatOnly,
                              null
                            ) > -1
                          : _vm.conservatory.variation.forBackgroundHeatOnly
                      },
                      on: {
                        change: function($event) {
                          var $$a =
                              _vm.conservatory.variation.forBackgroundHeatOnly,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.conservatory.variation,
                                  "forBackgroundHeatOnly",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.conservatory.variation,
                                  "forBackgroundHeatOnly",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(
                              _vm.conservatory.variation,
                              "forBackgroundHeatOnly",
                              $$c
                            )
                          }
                        }
                      }
                    })
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "step" }, [
            _c("h2", [_vm._v("Total")]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "calculate",
                on: { click: _vm.conservatoryCalculate }
              },
              [_vm._v("Calculate")]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "total" }, [
              _vm._v("Your room requires an output of... "),
              _c("span", { staticClass: "field inline" }, [
                _c("input", {
                  attrs: { disabled: "" },
                  domProps: { value: _vm.conservatory.lastCalculatedValue }
                }),
                _c("span", [_vm._v(" WATTS")])
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }